import { LayoutType_Enum, LocalContact } from '@weave/schema-gen-ts/dist/schemas/phone/devices/v2/devices.pb';

export const isLocalContactExtension = (extension: any): extension is LocalContact => 'contactId' in extension;
export const isHandheldLayout = (model?: { layoutType?: LayoutType_Enum | null }) =>
  model?.layoutType === LayoutType_Enum.HANDHELD;
export const truncateLineKeyName = (name: string | undefined) => {
  if (!name) return '';
  return name.length > 10 ? name.substring(0, 10) + '...' : name;
};
